module.exports = __webpack_public_path__ + "static/nds-logo-e996d656290d41286ca8b41c584e6986.png";